import { request } from '@/common/services/request';

export const queryOperationAnalysisSubjects = (params) =>
  request('/api/operations/tenant/analysis-subjects', {
    method: 'GET',
    params,
  });
